// src/pages/Reserva.js
import React, { useMemo, useState } from 'react'
import './Login.css' // reutiliza tu estilo actual (login-hero, login-box, etc.)
import { useNavigate } from 'react-router-dom'

// ---------- RUT helpers ----------
const cleanRut = (rut) =>
  (rut || '')
    .toUpperCase()
    .replace(/[^0-9K]/g, '')
    .trim()

const rutDV = (cuerpo) => {
  let suma = 0
  let mul = 2
  for (let i = cuerpo.length - 1; i >= 0; i--) {
    suma += Number(cuerpo[i]) * mul
    mul = mul === 7 ? 2 : mul + 1
  }
  const res = 11 - (suma % 11)
  if (res === 11) return '0'
  if (res === 10) return 'K'
  return String(res)
}

// Formato en vivo: xx.xxx.xxx-x
const formatRutLive = (input) => {
  const r = cleanRut(input)
  if (!r) return ''

  const dv = r.length >= 2 ? r.slice(-1) : ''
  let cuerpo = r.length >= 2 ? r.slice(0, -1) : r
  cuerpo = cuerpo.slice(0, 8)

  const rev = cuerpo.split('').reverse()
  const parts = []
  for (let i = 0; i < rev.length; i += 3) {
    parts.push(rev.slice(i, i + 3).reverse().join(''))
  }
  const cuerpoConPuntos = parts.reverse().join('.')
  return r.length >= 2 ? `${cuerpoConPuntos}-${dv}` : cuerpoConPuntos
}

const isRutValid = (rutFormateado) => {
  const r = cleanRut(rutFormateado)
  if (r.length < 8 || r.length > 10) return false
  const cuerpo = r.slice(0, -1)
  const dv = r.slice(-1)
  if (!/^\d+$/.test(cuerpo)) return false
  return rutDV(cuerpo) === dv
}
// --------------------------------

export default function Reserva() {
  const [rut, setRut] = useState('')
  const [error, setError] = useState(null)
  const nav = useNavigate()

  const titulo = useMemo(() => '🍽️ Reserva de Almuerzo', [])
  const subtitulo = useMemo(
    () => 'Ingresa tu RUT para programar tus almuerzos del mes.',
    []
  )

  const handleSubmit = (e) => {
    e.preventDefault()
    setError(null)

    const rutFmt = formatRutLive(rut)
    setRut(rutFmt)

    if (!isRutValid(rutFmt)) {
      setError('❌ RUT inválido. Revisa el dígito verificador (DV).')
      return
    }

    localStorage.setItem('rut_almuerzo', rutFmt)

    nav(`/almuerzoMes?rut=${encodeURIComponent(rutFmt)}`, {
      replace: true,
      state: { rut: rutFmt },
    })
  }

  const handleLimpiar = () => {
    setRut('')
    setError(null)
  }

  return (
    <section className="hero is-fullheight login-hero">
      <div className="hero-body">
        <div className="container" style={{ maxWidth: 480 }}>
          <div className="box login-box">
            <div className="has-text-centered mb-4">
              <h1 className="title mb-1">{titulo}</h1>
              <p className="has-text-grey">{subtitulo}</p>
            </div>

            {error && <div className="notification is-danger is-light">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="field">
                <label className="label">RUT</label>
                <div className="control has-icons-left">
                  <input
                    className="input"
                    type="text"
                    value={rut}
                    onChange={(e) => setRut(formatRutLive(e.target.value))}
                    required
                    placeholder="12.345.678-9"
                    inputMode="text"
                    maxLength={12}
                    autoFocus
                  />
                  <span className="icon is-small is-left">
                    <i className="fas fa-id-card" />
                  </span>
                </div>

                <p className="help">
                  Formato automático: <b>12.345.678-9</b>.
                </p>
              </div>

              <div className="field mt-4">
                <button className="button is-fullwidth is-link" type="submit">
                  <span className="icon is-small">
                    <i className="fas fa-arrow-right" />
                  </span>
                  <span>Continuar</span>
                </button>
              </div>

              <div className="field mt-3">
                <button className="button is-fullwidth is-light" type="button" onClick={handleLimpiar}>
                  Limpiar
                </button>
              </div>
            </form>
          </div>

          <p className="has-text-centered has-text-grey-light mt-4" style={{ fontSize: 12 }}>
            SistemaRAB · CasinoApp
          </p>
        </div>
      </div>
    </section>
  )
}
